export const accountTypesConstants = {
  ADMINISTRATOR: 100,
  PCCW_SALES: 110,
  PCCW_PRODUCT: 120,
  PCCW_OPERATION: 130,
  PCCW_BILLING: 140,

  MASTER: 200,
  SUB_ACCOUNT_SALES: 210,
  SUB_ACCOUNT_PRODUCT: 220,
  SUB_ACCOUNT_OPERATION: 230,
  SUB_ACCOUNT_BILLING: 240,
  REGISTERED: 400,

  VISITOR: 500,
  100: 'administrator',
  110: 'pccwglobal_sales',
  120: 'pccwglobal_product',
  130: 'pccwglobal_operation',
  140: 'pccwglobal_billing',
  200: 'master',
  210: 'sub-account-sales',
  220: 'sub-account-product',
  230: 'sub-account-operation',
  240: 'sub-account-billing',
  400: 'registered',
  500: 'visitor',

  ACCOUNT_ADD_PCCW: [{
    // id = 1
    account_type: 'administrator',
    id: 100,


  },
  {
    // id = 2
    account_type: 'pccwglobal_sales',
    id: 110,


  },
  {
    // id = 3
    account_type: 'pccwglobal_product',
    id: 120,


  },
  {
    // id = 4
    account_type: 'pccwglobal_operation',
    id: 130,


  },
  {
    // id = 5
    account_type: 'pccwglobal_billing',
    id: 140,


  },
  {
    // id = 6
    account_type: 'master',
    id: 200,


  }],
  ACCOUNT_CUSTOMER_ADD: [,
    {
      // id = 7
      account_type: 'sub-account-sales',
      id: 210,


    },
    {
      // id = 8
      account_type: 'sub-account-product',
      id: 220,


    },
    {
      // id = 9
      account_type: 'sub-account-operation',
      id: 230,


    },
    {
      // id = 10
      account_type: 'sub-account-billing',
      id: 240,


    }]
};
